import "animate.css";
import { Formatter, closeLoading, openLoading, useApi } from "gf-ui";
import { useEffect, useRef, useState } from "react";
import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { FaCalendarAlt, FaCheckCircle, FaClock, FaEdit, FaEnvelope, FaFrown, FaInfoCircle, FaMeh, FaPhone, FaSignOutAlt, FaSmile, FaTimesCircle } from 'react-icons/fa';
import { RiSurveyLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { apiQuestionario } from "../api/apiQuestionario";
import Agenda from '../components/Agenda';
import BtnContatta from "../components/BtnContatta";
import BtnStampa from "../components/BtnStampa";
import TelefonoEmail from "../components/TelefonoEmail";

const QRisultato = ({ homeRoute, root }) => {  
  const pageData = useSelector( state => state.page.data )
  const location = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()  
  const _apiQuestionario = useApi(apiQuestionario, null, root)
  const shouldInit = useRef(true)
  const [telefono, setTelefono] = useState("")
  const [email, setEmail] = useState("")
  const [privacy, setPrivacy] = useState(false)
  const [showInfo, setShowInfo] = useState(false)
  const [agenda, setAgenda] = useState({
    giorno: "",
    orario: {
      ID_DISPONIBILITA: null,
      orario: ""
    }
  });

  const cancellaAppuntamento = () => {
    setAgenda({ giorno: "", orario: { ID_DISPONIBILITA: null, orario: "" } })
    setTelefono("")
    setEmail("")
  }

  /*
  const [agendaCS, setAgendaCS] = useState({
    giorno: "",
    orario: ""
  }); 
  */

  const termina = (e) => {
    e.preventDefault();

    openLoading(dispatch)

    if (telefono !== "" || (agenda.giorno !== "" && agenda.orario.orario !== "")) {

      const params = {
        TELEFONO: agenda.orario.ID_DISPONIBILITA ? telefono : "",
        EMAIL: agenda.orario.ID_DISPONIBILITA ? email : "",
        ID_CALENDARIO_DISP: agenda.orario.ID_DISPONIBILITA ? agenda.orario.ID_DISPONIBILITA : "",
        FLG_PRIVACY_ACCETTATA: privacy ? "-1" : "0",
        ID_SCHEDA: location.state.ID_SCHEDA
      }

      _apiQuestionario.fnTermina((res) => {
        if (res.error_code !== undefined && res.error_code === "02") {
          setAgenda({
            giorno: "",
            orario: {
              ID_DISPONIBILITA: null,
              orario: ""
            }
          })
        } else {
          navigate(`${homeRoute}`)
        }
      }, params)

    } else {
      closeLoading(dispatch)
      setShowInfo(true)
    }
  }

  const onCloseInfo = () => {
    navigate(homeRoute);
  }

  const selectOrarioVS = (giorno, orario) => {
    setAgenda({
      giorno: giorno,
      orario: {
        ID_DISPONIBILITA: orario.ID_DISPONIBILITA,
        orario: orario.orario
      }
    });
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (shouldInit.current && _apiQuestionario) {
      shouldInit.current = false
      _apiQuestionario.setFixedParams({
        ID_SCHEDA: location.state.ID_SCHEDA
      })
    }
  }, [_apiQuestionario, location.state.ID_SCHEDA])

  return (
    <Container fluid="lg" className="mt-lg-4 mb-lg-4 p-0 rounded-lg">
      
      <div className="mt-4 p-md-4" style={{ borderRadius: 20, backgroundColor: 'white' }}>
        <div className="text-center p-2">
          {location.state.risultato.CLASSE_CSS === "success" && (
            <div>
              <h1 style={{ fontSize: '120px' }}><FaSmile className="text-success" /></h1>
              <h3 className="text-success fw-bold" dangerouslySetInnerHTML={{ __html: location.state.risultato.DESCRIZIONE }} />
            </div>
          )}
          {location.state.risultato.CLASSE_CSS === "warning" && (
            <div>
              <h1 style={{ fontSize: '120px' }}><FaMeh className="text-warning" /></h1>
              <h3 className="text-warning fw-bold" dangerouslySetInnerHTML={{ __html: location.state.risultato.DESCRIZIONE }} />
            </div>
          )}
          {location.state.risultato.CLASSE_CSS === "danger" && (
            <div>
              <h1 style={{ fontSize: '120px' }}><FaFrown className="text-danger" /></h1>
              <h3 className="m-0 text-danger fw-bold" dangerouslySetInnerHTML={{ __html: location.state.risultato.DESCRIZIONE }} />
            </div>
          )}
          {location.state.TOTALE_PESO !== undefined && !Formatter.isStringaVuota(location.state.TOTALE_PESO) && Formatter.getBoolean(location.state.risultato.FLG_MOSTRA_PESO) && (
            <div className="my-4">
              <h2 className="m-0 d-inline">Risultato <span className={`bg-light border rounded-circle py-2 px-3 fw-bold text-${location.state.risultato.CLASSE_CSS}`}>{location.state.TOTALE_PESO}</span></h2>
            </div>
          )}
        </div>
        <Form onSubmit={(e) => termina(e)}>
          <div className={`bg-light border rounded mt-3 p-4`} style={{ fontSize: '1.2rem' }}>
            <div className="d-flex flex-row align-items-center justify-content-center">
              <FaCheckCircle color="green" className="me-2" />
              <label>Scheda salvata con numero <strong>{location.state.NUMERO_ANNO}</strong></label>
            </div>
            {typeof location.state.MEX_NUMERO_NOTA !== "undefined" && (
              <>
                <div className="mt-2 d-flex flex-row align-items-center justify-content-center">
                  <FaEdit color="coral" className="me-2" />
                  <label><u>{location.state.MEX_NUMERO_NOTA}</u></label>
                </div>
              </>
            )}

            {typeof location.state.MESSAGGI !== "undefined" && location.state.MESSAGGI.map((messaggio, idx_msg) =>
              <div key={idx_msg}>
                <div className="icon-label mt-4">
                  <FaInfoCircle color="steelblue" className="mt-2" />
                  <label>{messaggio}</label>
                </div>
              </div>
            )}

            <Row>
              <Col xs={12} md={12}>
                <div style={{ paddingTop: 50, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <Agenda apiClient={_apiQuestionario}
                    btnLabel={pageData?.LABEL_BTN_APPUNTAMENTO}
                    bgColor="steelblue"
                    selectOrario={selectOrarioVS}
                    agenda={agenda} />

                  {agenda.giorno !== "" && (
                    <>
                      <div className="bg-white p-4 border rounded">
                        <div style={{ fontWeight: 800 }} className="text-center text-md-left">Giorno / orario selezionati</div>
                        <div>Giorno: <strong className="animate__animated animate__wobble">{agenda.giorno}</strong></div>
                        <div>Orario: <strong className="animate__animated animate__heartBeat">{agenda.orario.orario}</strong></div>
                        <div style={{ fontWeight: 800 }} className="text-center text-md-left">{location.state.MOD_NOTE !== "" ? location.state.MOD_NOTE : location.state.CAT_NOTE}</div>
                        <div className="w-100 d-flex flex-row align-items-center justify-content-center">
                          <Button variant="outline-danger" className="mt-4" onClick={cancellaAppuntamento}><FaTimesCircle /> Cancella</Button>
                        </div>
                      </div>
                      <Row>
                        <Col xs={12} md={{ span: 8, offset: 2 }} >

                          <TelefonoEmail telefono={telefono}
                            onChangeTelefono={val => setTelefono(val)}
                            email={email}
                            onChangeEmail={val => setEmail(val)}
                            privacy={privacy}
                            onChangePrivacy={(val) => setPrivacy(val)}
                          />

                        </Col>
                      </Row>
                    </>
                  )}
                </div>
              </Col>              
            </Row>
          </div>

          <div className="mt-4 text-center d-grid gap-2">
            <Button type="submit" variant="primary" size="lg" >
              <FaSignOutAlt /> Termina
            </Button>
          </div>

        </Form>
      </div>
      <Modal show={showInfo} size="lg" className="d-flex modal-dialog-centered" backdrop="static">
        <Modal.Header className="py-2 px-3 bg-primary text-light"><div>SCHEDA NUMERO <strong>{location.state.NUMERO_ANNO}</strong></div></Modal.Header>
        <Modal.Body >
          <Row>
            <Col xs={12} md={6} lg={3}>
              <div className="d-inline-block bg-light border rounded-circle d-flex flex-column align-items-center justify-content-center" style={{ width: '100px', height: '100px' }}>
                <h1 className="d-inline display-4">
                  <RiSurveyLine color="var(--bs-primary)" />
                </h1>
              </div>
            </Col>
            <Col xs={12} md={6} lg={9}>
              <div className="p-2">
                <p className="mb-0 fw-bold">ESITO</p>
                {location.state.risultato.CLASSE_CSS === "success" && (
                  <p className="text-success fw-bold" dangerouslySetInnerHTML={{ __html: location.state.risultato.DESCRIZIONE }} />
                )}
                {location.state.risultato.CLASSE_CSS === "warning" && (
                  <p className="text-warning fw-bold" dangerouslySetInnerHTML={{ __html: location.state.risultato.DESCRIZIONE }} />
                )}
                {location.state.risultato.CLASSE_CSS === "danger" && (
                  <p className="text-danger fw-bold" dangerouslySetInnerHTML={{ __html: location.state.risultato.DESCRIZIONE }} />
                )}
                {location.state.TOTALE_PESO !== undefined && !Formatter.isStringaVuota(location.state.TOTALE_PESO) && Formatter.getBoolean(location.state.risultato.FLG_MOSTRA_PESO) && (
                  <div className="my-4">
                    <h2 className="m-0 d-inline">Risultato <span className={`bg-light border rounded-circle py-2 px-3 fw-bold text-${location.state.risultato.CLASSE_CSS}`}>{location.state.TOTALE_PESO}</span></h2>
                  </div>
                )}
              </div>
              {agenda.giorno !== "" && (
                <>
                  <div className="p-2 border rounded bg-light d-flex flex-column align-itens-start justify-content-start">
                    <h3>Appuntamento</h3>
                    <span style={{ fontSize: '1.2em' }}><FaCalendarAlt /> Giorno: <strong>{agenda.giorno}</strong></span>
                    <span style={{ fontSize: '1.2em' }}><FaClock /> Orario: <strong>{agenda.orario.orario}</strong></span>
                  </div>
                  <div className="mt-2 p-2 border rounded bg-light d-flex flex-column align-itens-start justify-content-start">
                    <h3>I tuoi contatti</h3>
                    <span style={{ fontSize: '1.2em' }}><FaPhone /> Telefono: <strong>{telefono}</strong></span>
                    <span style={{ fontSize: '1.2em' }}><FaEnvelope /> Email: <strong>{email ? email : '-'}</strong></span>
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <BtnStampa             
            apiClient={_apiQuestionario} 
            modello={location && location.state && location.state.MODELLO}                      
            numeroScheda={location && location.state && location.state.NUMERO_ANNO}                      
          />

          {location.state.FLG_CONTATTA === "-1" && (
            <BtnContatta apiClient={_apiQuestionario}
              email={email}
              onChangeEmail={val => setEmail(val)}
              idScheda={location.state.ID_SCHEDA}
            />
          )}
          <Button variant="outline-secondary" size="lg" onClick={onCloseInfo}>Fine</Button>
        </Modal.Footer>
      </Modal>

    </Container>
  )
}

export default QRisultato;